import React from 'react'

const StiTestingService = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding5rem1 right-padding5rem1 py-md-5 py-4'>
            <div className=''>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pe-md-0 pe-2 pb-2'>
                    Our STD Testing Service Puts Your Health First
                </div>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='py-3'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                We believe in the power of open and honest communication when discussing sexual history and STD testing. Our compassionate healthcare professionals are here to listen, provide guidance, and offer confidential testing options. We understand that discussing STDs can sometimes be uncomfortable, so we strive to create a safe and non-judgmental environment for all our patients.
                </div>
            </div>

            <div className='pt-2'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                In partnership with Albertsons, we bring you a comprehensive and affordable solution. With our integrated services, you can conveniently access testing and necessary medications all in one place. Your health and privacy are our top priorities, and we ensure that your information remains confidential throughout the process.
                </div>
            </div>
        </div>
    </div>
  )
}

export default StiTestingService